import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import Utils, { getTimeOffsetMilliSeconds } from "../utils";
import { CSVRecordEyeTrackingEvent, CSVRecordKeyboardEvent, CSVRecordMouseEvent, CSVRecordMouseMovement } from "../shared/types/csv-model";
import { parse } from "date-fns";
import { MatSnackBar } from '@angular/material/snack-bar';
import { VgApiService, VgStates } from '@videogular/ngx-videogular/core';
import { FileDataType } from '../file-input/recorded-data-enums';
import { CommunicationService } from '../services/communication.service';
import { Subscription } from 'rxjs';
import { VideoService } from '../services/video.service';

@Component({
  selector: 'app-present-data',
  templateUrl: './present-data.component.html',
  styleUrls: ['./present-data.component.scss'],
  providers: [VideoService]
})

export class PresentDataComponent implements OnInit, OnDestroy {
  videoUrl: string | ArrayBuffer = null;
  screenFile: File;
  subscriptions: Subscription;
  videoApi: VgApiService;
  mouseEventRecords: CSVRecordMouseEvent[] = [];
  eyeTrackingEventRecords: CSVRecordEyeTrackingEvent[] = [];
  keyboardEventRecords: CSVRecordKeyboardEvent[] = [];
  requestInputs: FileDataType = FileDataType.MouseEventsSynced | FileDataType.KeyboardEventsSynced | FileDataType.EyeTrackingSynced | FileDataType.ScreenVideo;

  get isVideoPlayerPlaying() {
    return this?.videoApi.state === VgStates.VG_PLAYING;
  }

  constructor(private snackbar: MatSnackBar, private cdr: ChangeDetectorRef, private comData: CommunicationService) { }

  // subscribe to the cached files so we can get the file we want

  ngOnInit() {
    const fileSub = this.comData.getCachedFile(FileDataType.ScreenVideo).subscribe((CachedFile) => {
      if (CachedFile) {
        this.screenFile = CachedFile.file;
        this.readVideoFile(CachedFile.file);
      }
    });

    const mouseEventSub = this.comData.getCachedFile(FileDataType.MouseEventsSynced).subscribe((CachedFile) => {
      if (CachedFile) {
        this.readMouseEvents(CachedFile.file);
      }
    });
    const eyeTrackingSub = this.comData.getCachedFile(FileDataType.EyeTrackingSynced).subscribe((CachedFile) => {
      if (CachedFile) {
        this.readEyeTracking(CachedFile.file);
      }
    });
    const keyboardEventsSub = this.comData.getCachedFile(FileDataType.KeyboardEventsSynced).subscribe((CachedFile) => {
      if (CachedFile) {
        this.readKeyboardEvents(CachedFile.file);
      }
    });

    this.subscriptions = new Subscription();
    this.subscriptions.add(fileSub);
    this.subscriptions.add(mouseEventSub);
    this.subscriptions.add(eyeTrackingSub);
    this.subscriptions.add(keyboardEventsSub);
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
    this.subscriptions = null;
  }
  // TODO csv parsing *needs* a standard to handle it, it's currently copypasta hell
  readMouseEvents(file: File) {
    const u = new Utils();

    if (u.isValidCSVFile(file)) {
      const reader = new FileReader();
      reader.readAsText(file);
      let csvRecordsArray = [];
      const mouseEvents = [];

      reader.onload = () => {
        const csvData = reader.result;
        csvRecordsArray = (csvData as string).split(/\r\n|\n/);
        const startTimestamp = parse('0:00:00.0', 'HH:mm:ss.SSS', new Date());

        for (let i = 1; i < csvRecordsArray.length; i++) { // starts at 1 to skip the header
          const currentRecord = (csvRecordsArray[i] as string).split(',');
          const csvRecord: CSVRecordMouseEvent = new CSVRecordMouseEvent();

          const timeDate = parse(currentRecord[0].trim(), 'HH:mm:ss.SSS', new Date());
          csvRecord.timeColumn = String(this.getSecondsDifference(startTimestamp, timeDate)); // Inconsistent data with the other csvRecords
          csvRecord.buttonNameColumn = currentRecord[1].trim();
          csvRecord.stateColumn = currentRecord[2].trim();
          csvRecord.xColumn = Number(currentRecord[3].trim());
          csvRecord.yColumn = Number(currentRecord[4].trim());
          mouseEvents.push(csvRecord);
        }
        this.mouseEventRecords = mouseEvents;
        console.log(this.mouseEventRecords);

      };

      reader.onerror = () => {
        console.log('error is occurred while reading file!');
      };
    } else {
      this.snackbar.open('Uploaded file is invalid.', 'Dismiss');
    }
  }

  readEyeTracking(file: File) {
    const u = new Utils();
    // const text = [];

    if (u.isValidCSVFile(file)) {
      try {
        const reader = new FileReader();
        reader.readAsText(file);
        let csvRecordsArray = [];
        this.eyeTrackingEventRecords = [];

        reader.onload = () => {
          try {
            const csvData = reader.result;
            csvRecordsArray = (csvData as string).split(/\r\n|\n/);
            const startTimestamp = parse('0:00:00.0', 'HH:mm:ss.SSS', new Date());

            for (let i = 1; i < csvRecordsArray.length; i++) {
              const currentRecord = (csvRecordsArray[i] as string).split(',');
              const csvRecord: CSVRecordEyeTrackingEvent = new CSVRecordEyeTrackingEvent();

              const timeDate = parse(currentRecord[0].trim(), 'HH:mm:ss.SSS', new Date());
              csvRecord.timeColumn = String(this.getSecondsDifference(startTimestamp, timeDate)); // Inconsistent data with the other csvRecords
              csvRecord.LeftEyeXColumn = Number(currentRecord[1].trim());
              csvRecord.LeftEyeYColumn = Number(currentRecord[2].trim());
              csvRecord.RightEyeXColumn = Number(currentRecord[3].trim());
              csvRecord.RightEyeYColumn = Number(currentRecord[4].trim());

              this.eyeTrackingEventRecords.push(csvRecord);
            }
            console.log('eye tracking count ', this.eyeTrackingEventRecords.length);
          } catch (e) {
            this.snackbar.open("Failed to read the file");
            throw e;
          }
        };


        reader.onerror = () => {
          console.log('error occurred while reading file!');
        };
      } catch (e) {
        this.snackbar.open(`Failed to read the file`, 'Dismiss');
        throw e;
      }
    } else {
      this.snackbar.open('Uploaded file is invalid.', 'Dismiss');
    }

  }

  readKeyboardEvents(file: File) {
    const u = new Utils();

    if (u.isValidCSVFile(file)) {
      const reader = new FileReader();
      reader.readAsText(file);
      let csvRecordsArray = [];
      this.keyboardEventRecords = [];

      reader.onload = () => {
        const csvData = reader.result;
        csvRecordsArray = (csvData as string).split(/\r\n|\n/);
        const startTimestamp = parse('0:00:00.0', 'HH:mm:ss.SSS', new Date());

        for (let i = 1; i < csvRecordsArray.length; i++) {
          const currentRecord = (csvRecordsArray[i] as string).split(',');
          const csvRecord: CSVRecordKeyboardEvent = new CSVRecordKeyboardEvent();

          csvRecord.timeColumn = String(getTimeOffsetMilliSeconds(currentRecord[0].trim(), startTimestamp));
          csvRecord.buttonNameColumn = currentRecord[1].trim();
          csvRecord.stateColumn = currentRecord[2].trim();
          this.keyboardEventRecords.push(csvRecord);
        }
      };

      reader.onerror = () => {
        console.log('error is occurred while reading file!');
      };
    } else {
      this.snackbar.open('Uploaded file is invalid.', 'Dismiss');
    }
  }

  readVideoFile(file: File) {
    const reader = new FileReader();

    reader.onload = () => {
      this.videoUrl = reader.result;
    };
    reader.readAsDataURL(file);
  }

  fileChange(files: File[]) {
    if (files.length > 0) {
      this.screenFile = files[0];
    }
  }


  /**
   * this is used to perform the actual upload
   */
  upload() {
    console.log('sending this to server', this.screenFile);
  }

  onVideoReady(api: VgApiService) {
    if (!api) throw new Error("Video ready event did not provide a api object");
    this.videoApi = api;
    this.cdr.detectChanges();
  }

  playPauseVideo() {
    const video = this.videoApi;
    if (!this.isVideoPlayerPlaying) {
      video.play();
    } else {
      video.pause();
    }
  }

  onVideoEnd() {
    this.mouseEventRecords.forEach((event) => {
      event.eventShown = false;
    });

    this.eyeTrackingEventRecords.forEach((event) => {
      event.eventShown = false;
    });
  }

  getMatchingMousePosition(eventTime: number): CSVRecordMouseMovement {
    if (!this.mouseEventRecords.length) {
      return null;
    }

    let closestPosition: CSVRecordMouseMovement | null = null;
    let closestDifference = Infinity;

    for (const position of this.mouseEventRecords) {
      const timeDifference = Math.abs(eventTime - Number(position.timeColumn));

      if (timeDifference < closestDifference) {
        closestDifference = timeDifference;
        closestPosition = position;
      }
    }

    return closestPosition;
  }

  getSecondsDifference(startDate: Date, endDate: Date): number {
    const endTime = endDate.getTime();
    const startTime = startDate.getTime();
    const differenceInMilliseconds = endTime - startTime;
    const differenceInSeconds = differenceInMilliseconds / 1000;

    return differenceInSeconds;
  }
}

